import { HelpService } from './../../../shared/services/help/help.service';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UiService } from 'app/shared/services/ui/ui.service';
import { environment } from 'environments/environment';
import { Help } from 'app/shared/models/class/help/help';

export interface DialogData {
  helpVideoKey: number;
  help: Help;
}

@Component({
  selector: 'app-open-dialog-help',
  templateUrl: './open-dialog-help.component.html',
  styleUrls: ['./open-dialog-help.component.scss']
})
export class OpenDialogHelpComponent implements OnInit {
  help: Help = null;
  isLoading = false;
  baseUrl: string = environment.apiUrl;

  constructor(
    public dialogRef: MatDialogRef<OpenDialogHelpComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private uiSrv: UiService,
    private helpSrv: HelpService
  ) { }

  ngOnInit(): void {
    this.initSub();
  }

  private initSub() {
    this.isLoading = true;
    // if (!this.data.help) {

      this.helpSrv.getHelpByKey(this.data.helpVideoKey).subscribe(help => {
        this.help = help;
        this.isLoading = false;
      });
    // } else {
    //   this.help = this.data.help;
    //   this.isLoading = false;
    // }
  }

}
